import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { fakeTableList, schema } from "./parts";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_ACC014 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_ACC014_Request } from "../../type/apiType";

/**
 * SCRR010002 請求者入力
 * @return SCRR010002 請求者入力
 */
const SCRR010002 = () => {
  const navigate = useNavigate();
  // アクセスIDを取得
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const access_id = queryParams.get("access_id");
  const [statecorpInfoList] = useState(fakeTableList);
  const { state, setState } = useContext(GlobalContext);
  const [tel, setTel] = useState("");

  useEffect(() => {
    let resArr = statecorpInfoList;
    let demanderPhoneNumber = resArr.find(
      (item) => item.keyword === "demanderPhoneNumber"
    )!;

    demanderPhoneNumber.onGetInputValue = (value: any) => {
      setTel(value.target.valueForShow);
    };
  });

  const onCheckAndSubmit = async (data: any) => {
    if (data.email === data.email2) {
      try {
        const reqObj: IAPI_ACC014_Request = {
          name: data.demanderNameKanji,
          kana: data.demanderNameKana,
          birthday: data.birthday,
          tel: tel,
          email: data.email,
          accessUrlId: access_id!,
        };
        const res = await httpAPI_ACC014(reqObj);

        if (res.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          navigate("/SCRR010001", {
            state: {
              accessUrlId: access_id,
              userId: res.userId,
              userProcessKuben: "1",
            },
          });
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0001E",
      });
    }
  };
  return (
    <Box data-testid="SCRR010002PageForTest">
      <TkFakeTable
        list={statecorpInfoList}
        ruleSchema={schema}
        onCheckAndSubmit={(data) => {
          onCheckAndSubmit(data);
        }}
        submitButtonGroup={[
          {
            submitButtonDisabled: false,
            submitButtonText: "登録",
          },
        ]}
      />
    </Box>
  );
};

export default SCRR010002;
